import { z } from 'zod';
import { ActorSchema } from '../common/actor.schema';

/**
 * Emitted when an organisation's operating-model + legal-identity profile is
 * saved (IMM-285). Ids only on the payload per ADR 0015 §PII — the changed
 * field values are not carried.
 */
export const OrganizationUpdatedPayloadSchema = z.object({
  organizationId: z.uuid(),
  workspaceId: z.uuid(),
  actor: ActorSchema,
  occurredAt: z.iso.datetime(),
});

export type OrganizationUpdatedPayload = z.infer<typeof OrganizationUpdatedPayloadSchema>;
